import initialize_external_links from "../../shared/utils/initialize_external_links";

export default function() {
  const text =  "Das von Ihnen gewählte Angebot ist nicht Teil der BDC|eAkademie, sondern wird von einem externen Anbieter bereitgestellt. Mit diesem Link verlassen Sie das Angebot der BDC|eAkademie auf eakademie.bdc.de und gelangen zum gewählten Angebot.<p><strong>Weiter zum externen Angebot und die BDC|eAkademie verlassen?</strong></p>"
  initialize_external_links(text);
}
